var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.$vuetify.breakpoint.smAndDown && _vm.showFab
        ? _c("SoliBtn", {
            class: [
              _vm.selectedPeople.length ? "shadow-blue-xl" : "shadow-orange-xl",
              "mobile-fab",
              //$vuetify.breakpoint.smAndDown ? 'mobile-fab' : null
            ],
            attrs: {
              round: "",
              fab: "",
              fixed: "",
              right: "",
              loading: _vm.fabLoading,
              icon:
                _vm.fabIcon ?? (_vm.selectedPeople.length ? "email" : "add"),
              gradient: _vm.selectedPeople.length
                ? "gradient-blue"
                : "gradient-orange",
            },
            on: {
              click: function ($event) {
                return _vm.$emit("fabAction")
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-bottom-navigation",
        {
          staticClass: "bottom-nav-bar shadow-grey",
          attrs: { grow: "", app: "" },
        },
        _vm._l(
          _vm.items.filter((e) => e.permission),
          function (item) {
            return _c(
              "v-btn",
              {
                key: item.title,
                ref: "bottomNav",
                refInFor: true,
                class: [
                  "py-2 soli-link",
                  _vm.page === item.comp || _vm.page == item.link
                    ? "v-btn--active"
                    : "btn-force-inactive",
                ],
                attrs: { small: "", "active-class": "btn-force-inactive" },
                on: {
                  click: function ($event) {
                    return _vm.visit(item.link)
                  },
                },
              },
              [
                _c("span", { staticClass: "mt-1" }, [
                  _vm._v(_vm._s(item.title)),
                ]),
                _vm._v(" "),
                item.badge
                  ? _c(
                      "v-badge",
                      {
                        attrs: {
                          content: _vm.unreadMessageCount,
                          color: _vm.unreadMessageCount ? "soli-red" : null,
                          overlap: "",
                        },
                      },
                      [_c("v-icon", [_vm._v(_vm._s(item.icon))])],
                      1
                    )
                  : _c("v-icon", [_vm._v(_vm._s(item.icon))]),
              ],
              1
            )
          }
        ),
        1
      ),
      _vm._v(" "),
      _c("ProfileMenu", {
        attrs: { page: _vm.page },
        on: {
          locationSelect: function ($event) {
            return _vm.$emit("locationSelect")
          },
          close: function ($event) {
            _vm.profileMenu = false
          },
          success: function ($event) {
            return _vm.$emit("success")
          },
        },
        model: {
          value: _vm.profileMenu,
          callback: function ($$v) {
            _vm.profileMenu = $$v
          },
          expression: "profileMenu",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }